import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AppNavigationService } from '../services/app-navigation.service';
import { WebSocketService } from '../services/websocket.service';
import { WifiStatusService } from '../services/wifi-status.service';

@Component({
  selector: 'app-status-bar',
  templateUrl: './status-bar.component.html',
  styleUrls: ['./status-bar.component.css']
})
export class StatusBarComponent implements OnInit {

  // socketInfo$: BehaviorSubject<any>;
  socketInfo: any;

  // Store NETWORK Status
  offline = false;

  showBackButton: any;

  constructor(private appNavigationService: AppNavigationService,
              private webSocketService: WebSocketService,
              private wifiStatusSevice: WifiStatusService) 
              {

              }

  ngOnInit(): void 
  {

    this.getSocketStatus();
    this.getWifiStatusChange();
    this.getBackButtonStatus();

  }

  // ----------------------------------------------
  // Update the UI if the Network status changes
  // ----------------------------------------------
  getWifiStatusChange() 
  {
    this.wifiStatusSevice.wifiStatusSubject$.subscribe((data: any) => 
    {
      // console.log('Wifi Status :', data);
      this.offline = data;
    });
  }  

  // ----------------------------------------------
  // Update the UI if the Socket status changes
  // ----------------------------------------------
  getSocketStatus()
  {
    this.webSocketService.socketStatusSubject$.subscribe(
      (data: any) => 
      {
        // console.log('Status Bar -  getSocketStatus() :', data);
        this.socketInfo = data;
      }
    );    
  }


  // ----------------------------------------------
  // Update the UI if the Back Button status changes
  // ----------------------------------------------
  getBackButtonStatus()
  {
    this.appNavigationService.isShowBackSubject$.subscribe(
      (data: any) => 
      {
        this.showBackButton = data;
      }
    ); 
  }

  onBackButtonClicked()
  {
    console.log('window history back');
    window.history.back();
  }

}
